import { render } from "./ConfirmationRecallPage.vue?vue&type=template&id=65a1d624"
import script from "./ConfirmationRecallPage.vue?vue&type=script&lang=js"
export * from "./ConfirmationRecallPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__